import { render, staticRenderFns } from "./JsonView.vue?vue&type=template&id=717abd42&scoped=true&"
import script from "./JsonView.vue?vue&type=script&lang=js&"
export * from "./JsonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717abd42",
  null
  
)

export default component.exports